import styled from 'styled-components'

const StyledCheckoutHeader = styled.div`
  padding: 25px 0;
  margin-bottom: 30px;
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: ${({ theme }) => theme.color.background};
  box-shadow: 0 0px 2px rgb(0, 0, 0, 0.075), 0 0 10px rgb(0, 0, 0, 0.1);

  .header {
    max-width: 990px;
    margin: 0 auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      height: 40px;
    }

    .quit-btn {
      display: flex;
      align-items: center;
      font-weight: 500;
      text-decoration: none;
      transition: 0.2s;
      color: ${({ theme }) => theme.color.gray[400]};

      svg {
        height: 20px;
        width: 20px;
        stroke-width: 2.5px;
        margin-left: 4px;
      }

      &:hover {
        color: ${({ theme }) => theme.color.gray[900]};
      }
    }
  }
`

export default StyledCheckoutHeader
